import React, { memo, useState } from "react";
import styled from "styled-components";
import { Box, LinearProgress, Typography } from "@mui/joy";
import Uploady, {
    useUploady,
    useBatchAddListener,
    useItemFinalizeListener,
    useItemProgressListener,
    useAbortItem,
    FILE_STATES
} from "@rpldy/uploady";
import UploadButton from "@rpldy/upload-button";
import UploadDropZone from "@rpldy/upload-drop-zone";

export default function FileUploadTest() {
    const objectExists = false;
    const uploadUrl = "http://demo.maestrocm.local/api/filetest"
    return (
        <Uploady
            multiple
            grouped
            maxGroupSize={2}
            method="POST"
            destination={{ url: uploadUrl, headers: { "x-custom": "123" } }}
            autoUpload={objectExists}
        >
            <UploadDropZone
                onDragOverClassName="drag-over"
                grouped
                maxGroupSize={3}
            >
                <span>Drag&Drop File(s) Here</span>
                <Box>
                    <UploadButton extraProps={{type: 'button'}}/>
                    <Typography>Drag n drop</Typography>
                    <UploadList/>
                </Box>
            </UploadDropZone>
        </Uploady>
    );
}

const ListContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  margin-top: 20px;
`;

const UploadList = () => {
  const { processPending } = useUploady();
  const [items, setItems] = useState([]);

  useBatchAddListener((batch) => {
    setItems((items) => items.concat(batch.items));
  });

  return (
    <ListContainer>
      {items.map((item) => (
        <UploadListItem key={item.id} item={item} />
      ))}

      {items.length ? <button type="button" onClick={processPending}>Upload all</button> : null}
    </ListContainer>
  );
};

const ItemProgress = memo(({ id }) => {
    const { completed } = useItemProgressListener(id) || { completed: 0 };

    return <LinearProgress sx={{display: 'block',width: '100px'}} determinate value={completed}  />
    return <>{completed}</>
    /*
    return (
      <StyledCircle
        percent={completed}
        strokeWidth={2}
        trailColor="rgb(175,180,176)"
        strokeColor={{
          "0%": "#ffecb1",
          "100%": "#9eea9e"
        }}
      />
    );
    */
  });

  const ItemWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0;
    justify-content: flex-start;
  `;

  const ItemName = styled.span`
    display: inline-block;
    margin: 0 10px;

    ${({ $aborted }) => ($aborted ? "color: gray;" : undefined)}
    ${({ $success }) => ($success ? "color: green;" : undefined)}
  `;

  const UploadListItem = ({ item }) => {
    const [itemState, setState] = useState(item.state);

    const abortItem = useAbortItem();

    useItemFinalizeListener((item) => {
      setState(item.state);
    }, item.id);

    const isAborted = itemState === FILE_STATES.ABORTED,
      isSuccess = itemState === FILE_STATES.FINISHED,
      isFinished = ![FILE_STATES.PENDING, FILE_STATES.UPLOADING].includes(
        itemState
      );

    const onAbortItem = () => {
      abortItem(item.id);
    };

    if(isAborted) {
        return null;
    }

    return (
      <ItemWrapper>
        {!isFinished && <ItemProgress id={item.id} />}
        {isAborted && <>ABORTED</>}
        {isSuccess && <>SUCCESS</>}
        <ItemName $aborted={isAborted} $success={isSuccess}>
          {item.file.name}
        </ItemName>
        {!isFinished && <div  onClick={onAbortItem} ><>abort</></div>}
      </ItemWrapper>
    );
  };
